module.exports = __webpack_public_path__ + "img/quality-02-landscape.cfc5cd82.jpg";